import React from "react";
import { useState, useEffect } from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface ConfigureTabProps {
  formData: any;
  onFormChange: (field: string, value: any) => void;
}

const ConfigureTab: React.FC<ConfigureTabProps> = ({ formData, onFormChange }) => {
  const handleTimeValueChange = (value: string) => {
    onFormChange('response_time_value', parseInt(value) || 10);
  };

  return (
    <form action="" className="w-full flex pb-8 flex-col gap-4">
      {/* name  */}
      <div className="flex w-full flex-col items-start gap-3">
        <Label htmlFor="name">Nome do assistente</Label>
        <Input
          placeholder="Name"
          id="name"
          value={formData.name || ''}
          onChange={(e) => onFormChange('name', e.target.value)}
          className="bg-neutral-600 !w-full text-[14px] placeholder:text-[#71717A] text-[#71717A] !h-[44px] border focus:ring-white border-[#3F3F46]"
          type="text"
        />
      </div>
      {/* Model ------>  */}
      <div className="flex w-full flex-col items-start gap-3">
        <Label htmlFor="model">Modelo</Label>
        <Select key="model-select" value={formData.model} onValueChange={(value) => onFormChange('model', value)}>
          <SelectTrigger className="w-full !h-[44px] rounded-[12px] bg-neutral-600">
            <SelectValue placeholder="Selecione um modelo" />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              {ModalOptions.map((item, index) => {
                return (
                  <SelectItem key={`model-${index}-${item}`} value={item}>
                    {item}
                  </SelectItem>
                );
              })}
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
      {/* Time to respond ---------------->  */}
      <div className="flex w-full flex-col items-start gap-3">
        <Label htmlFor="time-to-respond">Tempo para responder (segundos)</Label>
        <div className="flex items-center gap-3">
          <Select key="time-select" value={formData.response_time_value?.toString()} onValueChange={handleTimeValueChange}>
            <SelectTrigger className="w-full !h-[44px] rounded-[12px] bg-neutral-600">
              <SelectValue placeholder="10" />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                {TimeToRespondSecondsOptions.map((item, index) => {
                  return (
                    <SelectItem key={`time-${index}-${item}`} value={item}>
                      {item}s
                    </SelectItem>
                  );
                })}
              </SelectGroup>
            </SelectContent>
          </Select>
        </div>
        <p className="text-xs text-gray-400">
          Tempo de espera para agregar mensagens antes de processar. Útil quando usuários enviam múltiplas mensagens seguidas.
        </p>
      </div>
      {/* Maximum number of messages - hidden from UI, keeping data intact */}
    </form>
  );
};

export default ConfigureTab;

export const ModalOptions = ["gpt-5"];

export const TimeToRespondSecondsOptions = [
  "1",
  "2",
  "3",
  "5",
  "10",
  "15",
  "20",
  "30",
  "45",
  "60",
];

export const MaximumMessagesOptions = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "10",
  "30",
  "60",
];